// extracted by mini-css-extract-plugin
export default {"root":"Pagination_root__gWajI","layout":"Pagination_layout__ACTG5","end":"Pagination_end__UgHuC","divider":"Pagination_divider__SK8YJ","dividerEdge":"Pagination_dividerEdge__B7DKr"};